import React from 'react';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const DishCard = ({ dish, onViewDetails, onViewAR, hasARModel = false }) => {
  const chipConfig = {
    new: { label: 'New', className: 'bg-blue-500 text-white' },
    veg: { label: 'Veg', className: 'bg-green-500 text-white', icon: 'Leaf' },
    spicy: { label: 'Spicy', className: 'bg-red-500 text-white', icon: 'Flame' },
    popular: { label: 'Popular', className: 'bg-amber-500 text-white', icon: 'Star' },
  };

  const activeChips = Array.isArray(dish?.chips) ? dish?.chips : (dish?.chip ? [dish?.chip] : []);

  return (
    <div className="dish-card bg-card rounded-lg shadow-warm hover:shadow-warm-md transition-smooth overflow-hidden">
      <div 
        className="dish-image-container relative h-48 md:h-56 lg:h-64 overflow-hidden cursor-pointer group"
        onClick={() => onViewDetails(dish)}
      >
        <Image
          src={dish?.image}
          alt={dish?.imageAlt}
          className="w-full h-full object-cover transition-smooth group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent opacity-0 group-hover:opacity-100 transition-smooth" />
        <div className="absolute top-3 right-3 flex flex-col items-end gap-1">
          {activeChips?.map((chipKey) => {
            const chip = chipConfig?.[chipKey];
            if (!chip) return null;
            return (
              <span
                key={chipKey}
                className={`flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium shadow-warm ${chip?.className}`}
              >
                {chip?.icon && <Icon name={chip?.icon} size={12} className="inline" />}
                {chip?.label}
              </span>
            );
          })}
        </div>
      </div>
      <div className="dish-content p-4 md:p-5 lg:p-6">
        <div className="dish-header mb-3">
          <h3 
            className="text-lg md:text-xl font-heading font-semibold text-foreground mb-1 cursor-pointer hover:text-primary transition-smooth line-clamp-1"
            onClick={() => onViewDetails(dish)}
          >
            {dish?.name}
          </h3>
          <p className="text-sm md:text-base text-muted-foreground line-clamp-2">
            {dish?.description}
          </p>
        </div>

        <div className="dish-ingredients mb-4">
          <div className="flex items-start gap-2">
            <Icon name="ChefHat" size={16} className="text-muted-foreground mt-0.5 flex-shrink-0" />
            <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">
              {dish?.ingredients?.join(', ')}
            </p>
          </div>
        </div>

        <div className="dish-footer flex items-center justify-between gap-3">
          <div className="dish-price">
            <span className="text-2xl md:text-3xl font-heading font-bold text-primary">
              ${dish?.price?.toFixed(2)}
            </span>
            {dish?.originalPrice && (
              <span className="text-sm text-muted-foreground line-through ml-2">
                ${dish?.originalPrice?.toFixed(2)}
              </span>
            )}
          </div>

          {hasARModel ? (
            <Button
              variant="default"
              size="sm"
              onClick={() => onViewAR(dish)}
              iconName="Scan"
              iconPosition="left"
              iconSize={16}
              className="touch-target transition-smooth active:scale-96"
            >
              Voir en RA
            </Button>
          ) : (
            <Button
              variant="outline"
              size="sm"
              onClick={() => onViewDetails(dish)}
              iconName="Info"
              iconPosition="left"
              iconSize={16}
              className="touch-target transition-smooth active:scale-96"
            >
              Détails
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default DishCard;